import React from 'react';
import Contact from '../../components/contact'
import './style.scss';
const ContactPage = () => {
    return (
        <div className="contactus">
            <Contact />
        </div>
    )
}

export default ContactPage;